import { api } from "./api";

const API_BASE = `${import.meta.env.VITE_API_URL}/api/v1`;

export const referralServices = {
  generate: () => {
    return api.post(`${API_BASE}/referral/generate`);
  },

  getMyCode: () => {
    return api.get(`${API_BASE}/referral/my-code`);
  },

  getLatestCode: () => {
    return api.get(`${API_BASE}/referral/latest-code`);
  },

  deactivate: () => {
    return api.patch(`${API_BASE}/referral/deactivate`);
  },

  activate: () => {
    return api.patch(`${API_BASE}/referral/activate`);
  },

  getShareMessage: () => {
    return api.get(`${API_BASE}/referral/share-message`);
  },

  getMyReferrals: (page = 1, perPage = 10) => {
    return api.get(`${API_BASE}/referral/my-referrals`, {
      params: {
        page,
        per_page: perPage,
      },
    });
  },

  validate: (referralCode) => {
    return api.post(`${API_BASE}/referral/validate`, {
      referral_code: referralCode,
    });
  },
};
